import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useHubspotTracking = (path = "") => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname || path) {
      var _hsq = (window._hsq = window._hsq || []);
      _hsq.push(["setPath", path || pathname]);
      _hsq.push(["trackPageView"]);
    }
  }, [pathname, path]);
};

export default useHubspotTracking;
